import { initializeApp, type FirebaseApp } from "firebase/app";
import { getAnalytics, type Analytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

/**
 * Firebase 환경변수가 누락된 빌드(예: PR preview / 로컬 dev / 데모) 에서도
 * 페이지가 렌더되도록 init 을 conditional 로 처리한다. 운영 환경에서는
 * env 가 정상 주입되므로 동작에 영향 없다.
 */
const hasFirebaseConfig =
  Boolean(firebaseConfig.projectId) &&
  Boolean(firebaseConfig.apiKey) &&
  Boolean(firebaseConfig.appId);

export const app: FirebaseApp | null = hasFirebaseConfig ? initializeApp(firebaseConfig) : null;
export const analytics: Analytics | null = app ? getAnalytics(app) : null;
